/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * Business or private trip (FAFD-68). Only tenants that allow private trips offer the choice;
everywhere else every trip is a business trip. Travels as an int on the wire — never renumber.
 */
export type FacilityFlowCoreModulesFleetEntitiesTripPurposeKind = typeof FacilityFlowCoreModulesFleetEntitiesTripPurposeKind[keyof typeof FacilityFlowCoreModulesFleetEntitiesTripPurposeKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetEntitiesTripPurposeKind = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
